import { parseJwt } from "modules/common";
import { useState, useCallback, useEffect, useMemo } from "react";
import { CompanyMaster } from "models/companymaster/CompanyMaster";
import { useCompanyMaster } from "queries";

export function useUserInformation() {
	const [userCompanySids, setUserCompanySids] = useState<string[]>([]);
	const { data: companyMaster } = useCompanyMaster();

	const getUserInformation = useCallback(async () => {
		try {
			const token = localStorage.getItem("LG_APPLICATION");
			if (!token) {
				return;
			}

			const jsonData = JSON.parse(token);
			const accessToken = jsonData.access_token;
			if (!accessToken) {
				 return;
			}

			const jwt = parseJwt(accessToken);
			const extra = jwt?.extra ? JSON.parse(jwt.extra) : {};
			const userId = extra.username || extra.citizen_id || "";
			// const userId = "sitthisak.s"; // for test

			const response = await fetch(`/v1/user?id=${userId}`, {
				headers: { Authorization: `Bearer ${token}` },
			});

			const result = await response.json();

			const userData = result.result_list.find((i) => i.id === userId);
			if (!userData || !Array.isArray(userData.list_company)) {
				console.warn("No company list found for user:", userId);
				setUserCompanySids([]);

				return;
			}

			const sids = userData.list_company
				.map((company) => company.sid)
				.filter(Boolean);

			setUserCompanySids(sids);
		} catch (error) {
			console.error("Error fetching user info:", error);
		}
	}, []);

	useEffect(() => {
		getUserInformation();
	}, [getUserInformation]);

	const companyOptions = useMemo(() => {
		if (!companyMaster || companyMaster.length === 0) return [];

		const baseOptions: CompanyMaster[] = [
			{ sid: "all", company_name: "เลือกทั้งหมด" } as CompanyMaster,
		];

		let allowedCompanies: CompanyMaster[] = [];

		if (userCompanySids.includes("*")) {
			// Super admin: all companies, but avoid duplicates
			allowedCompanies = companyMaster.filter((c) => c.sid !== "*");

			baseOptions.push({
				sid: "*",
				company_name: "* : SUPER_ADMIN",
			} as CompanyMaster);
		} else {
			// Normal users: only their companies
			allowedCompanies = companyMaster.filter((c) =>
				userCompanySids.includes(c.sid)
			);
		}

		// Remove duplicates between baseOptions and allowedCompanies
		const options = baseOptions.concat(
			allowedCompanies.filter(
				(ac) => !baseOptions.some((b) => b.sid === ac.sid)
			)
		);

		return options;
	}, [companyMaster, userCompanySids]);

	return {
		userCompanySids,
		companyOptions,
		refresh: getUserInformation,
	};
}
